
/* Mini Miracle: show printing surcharges on all five bunny product pages.
   This changes only the visible labels, not variant option values. */
(function(){
  function updateLabels(){
    var data=document.getElementById('mm-v23-product-data');
    if(!data || !/happy-horse-knuffelkonijn/i.test(data.textContent||''))return;
    document.querySelectorAll('label, button, [role="radio"]').forEach(function(el){
      if(el.closest('.mm-hh, .mm-v23-bar, .mm-hh-pictures, .mm-hh-colors'))return;
      if(el.children.length && el.querySelector('label, button, [role="radio"]'))return;
      var t=(el.textContent||'').replace(/\s+/g,' ').trim();
      var target='';
      if(/^zonder bedrukking(?:\s*[+€].*)?$/i.test(t))target='Zonder bedrukking';
      else if(/^1 oor bedrukken(?:\s*[+€].*)?$/i.test(t))target='1 oor – Naam (+ €7,99)';
      else if(/^2 oren bedrukken(?:\s*[+€].*)?$/i.test(t))target='2 oren – Naam + datum (+ €12,98)';
      if(!target || t===target)return;
      // Only change a plain-text label; never rewrite interactive markup.
      var nodes=Array.from(el.childNodes).filter(function(n){return n.nodeType===3 && n.textContent.trim();});
      if(nodes.length===1 && nodes[0].textContent.trim()===t){
        nodes[0].textContent=target;
      }else if(!el.querySelector('input,svg,img,span,strong,small')){
        el.textContent=target;
      }
    });
  }
  document.addEventListener('DOMContentLoaded',updateLabels);
  document.addEventListener('change',function(){requestAnimationFrame(updateLabels)},true);
  document.addEventListener('click',function(){requestAnimationFrame(updateLabels)},true);
  updateLabels();
})();
